'use client'
import React, { useState, useEffect } from 'react'
// import parse from 'html-react-parser';
// import tailwindConfig from '@tailwind.config'
import Image from 'next/image';
import LinkComponent from '@components/LinkComponent';
// import AgentCardSliderWrapper from '@components/AgentCardSliderWrapper'
import TestamonialCardSliderWrapper from '@components/TestamonialCardSliderWrapper'
import PersonalizedService from '@components/PersonalizedService'
import SellForm from '@components/SellForm'
import AgentRecruitment from '@components/AgentRecruitment'


function useBreakpoint() {
  const [bp, setBp] = useState('desktop')

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth
      if (w < 640) setBp('mobile')
      else if (w < 1024) setBp('tablet')
      else setBp('desktop')
    }

    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  return bp
}

function resolveHeight(value) {
  if (value === 'full') return '100vh'
  if (value === 'dvh') return '100dvh'
  if (typeof value === 'number') return value + 'px'
  return '600px'
}

const AboutComponent = ({ testamonials, contents, dictionary, lang }) => {
    const breakpoint = useBreakpoint()
    console.log(contents)
    return (
        <>
            {contents && contents.map((section) => {
                if (section.style === 'banner') {
                    return (
                        <div
                        key={section.id}
                        className="w-full relative overflow-hidden"
                        style={{ height: resolveHeight(section?.height?.[breakpoint]) }}
                        >
                        <div className="absolute z-10 inset-0 bg-black/60 to-transparent" />

                        <div className="absolute z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 2xl:w-10/12 max-w-[1600px] w-full p-2">
                            <div className="w-full p-4">
                                <h1 className="text-light text-4xl leading-10 tracking-wider text-center">
                                    {section.title?.[lang]}
                                </h1>

                                <p className="text-xl text-light mt-10 text-center">
                                    {section.subtitle1?.[lang]}
                                </p>

                                <p className="text-xl text-light mt-5 text-center">
                                    {section.subtitle2?.[lang]}
                                </p>
                            </div>
                        </div>

                        <div className="absolute z-10 inset-0 bg-maincolor opacity-20" />

                        <div className="relative h-full">
                            <Image
                            src={section.image || '/images/about/aboutus.jpg'}
                            fill
                            priority
                            className="object-cover"
                            alt="Banner Image"
                            />
                        </div>
                        </div>
                    )
                } 
                if (section.style === 'split') {
                    return (
                        <div key={section.id} className="container-wide mx-auto sm:my-6 my-2 sm:py-6 py-2">
                            <div
                            className={`w-full flex sm:flex-row flex-col gap-2 sm:px-0 px-2 ${
                                section?.layout == 'text-left' ? 'sm:flex-row-reverse' : 'sm:flex-row'
                            }`}
                            >
                            <div className="sm:w-1/2 w-full flex flex-col justify-center lg:p-0 p-2">
                                <h2 className="text-maincolor text-2xl font-bold mb-4">
                                {section.title?.[lang]}
                                </h2>
                                <div className="mb-4 prose max-w-none tiptap-content"
                                    dangerouslySetInnerHTML={{
                                        __html: section?.content1?.[lang] || '',
                                    }}
                                />
                                {/* <p className="mb-4">{section?.content2?.[lang]}</p> */}
                                {section?.buttonUrl && (
                                    <LinkComponent className='bg-third text-light text-center py-2 font-semibold sm:w-[320px] w-full' href={`/${section?.buttonUrl}`}>{section?.buttonText?.[lang]}</LinkComponent>
                                )}
                            </div>

                            <div className="sm:w-1/2 w-full lg:p-4 p-2 flex items-center justify-center">
                                <div className="rounded-sm border shadow-sm overflow-hidden">
                                    <Image
                                        src={section.image || '/images/about/about-us-1.jpg'}
                                        width={section.imageWidth || 600}
                                        height={section.imageHeight || 400}
                                        className="object-cover"
                                        alt="About"
                                    />
                                </div>
                            </div>
                            </div>
                        </div>
                    )
                }
                // if (section.style === 'agentList') {
                //     return (
                //         <div key={section.id} className='2xl:w-10/12 max-w-[1600px] mx-auto my-6'>
                //             <AgentCardSliderWrapper title={section?.title?.[lang]}  description={section?.subtitle1?.[lang]} dictionary={dictionary} lang={lang} />
                //         </div>
                //     )
                // }
                if (section.style === 'testamonialList') {
                    return (
                        <div key={section.id} className='container-wide mx-auto my-6'>
                            <TestamonialCardSliderWrapper testamonials={testamonials} title={section?.title?.[lang]}  description={section?.subtitle1?.[lang]} dictionary={dictionary} lang={lang} />
                        </div>
                    )
                }
                if (section.style === 'homesearchpanel') {
                    return (
                        <div key={section.id} className='container-wide mx-auto my-6'>
                            <PersonalizedService title={section?.title?.[lang]}  description={section?.subtitle1?.[lang]} dictionary={dictionary} lang={lang} />
                        </div>
                    )
                }
                if (section.style === 'listwithuspanel') {
                    return (
                        <div key={section.id} className='container-wide mx-auto my-6'>
                            <SellForm title={section?.title?.[lang]}  description={section?.subtitle1?.[lang]} dictionary={dictionary.sellForm} lang={lang} />
                        </div>
                    )
                }
                if (section.style === 'joinuspanel') {
                    return (
                        <AgentRecruitment title={section?.title?.[lang]}  content1={section?.content1?.[lang]} content2={section?.content2?.[lang]} dictionary={dictionary} lang={lang} />

                    )
                }
                else return null
            })}
        </>
    )
}

export default AboutComponent